import { useEffect, ReactNode } from 'react';

declare global {
    interface Window {
        google: any;
        ENV: {
            GOOGLE_MAPS_API_KEY: string;
        };
    }
}

let isLoading = false;
let isLoaded = false;

export function GoogleMapsLoader({ children }: { children: ReactNode }) {
    useEffect(() => {
        if (isLoaded) return;
        if (isLoading) return;
        if (window.google?.maps) {
            isLoaded = true;
            return;
        }

        // Get key from global ENV injected by Cloudflare
        const apiKey = window.ENV?.GOOGLE_MAPS_API_KEY;
        if (!apiKey) {
            console.error('Google Maps API Key not found in window.ENV');
            return;
        }

        isLoading = true;
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&language=th`;
        script.async = true;
        script.defer = true;
        script.onload = () => {
            isLoaded = true;
            isLoading = false;
        };
        script.onerror = () => {
            isLoading = false;
            console.error('Failed to load Google Maps API');
        };
        document.head.appendChild(script);
    }, []);

    return <>{children}</>;
}
